import "./RichDropdown.scss";

export default {
  root: "im-rich-dropdown",
  submenu: "im-rich-dropdown__submenu",
};
